import PropTypes from 'prop-types';
import React from 'react';

import { bubEvents } from 'javascripts/shared/events/bub_events';

import { AuthorCard } from 'javascripts/components/author_card';
import { CarouselWithGraphQL } from 'javascripts/components/carousel_with_graphql';

export function AuthorCardCarouselWithGraphQL(props) {
  function renderCarouselItems(peopleList, trackingCategory) {
    return peopleList.map((author, index) => (
      <AuthorCard
        author={author}
        key={author.slug}
        displayOrientation='vertical'
        hideFollowButtons
        linkAudiobooks
        showViewAllButton
        trackingProperties={{
          ...props.trackingProperties,
          carousel_horizontal_position: bubEvents.trackingIndex(index),
          tracking_category: trackingCategory,
        }}
      />
    ));
  }

  function renderResponse(graphQLResponse, trackingCategory) {
    if (graphQLResponse.loading) {
      return [];
    }

    if (!_.isEmpty(graphQLResponse.errors)) {
      throw graphQLResponse.errors[0];
    }

    const responseItems = props.fetchResponseItems(graphQLResponse);

    return renderCarouselItems(responseItems, trackingCategory);
  }

  function trackLinkClick() {
    bubEvents.track(props.trackingCategory, 'Clicked link', {
      label: props.linkText,
      ...props.trackingProperties,
    });
  }

  return (
    <CarouselWithGraphQL
      query={props.query}
      queryParams={props.queryParams}
      title={props.title}
      renderResponseFunction={renderResponse}
      trackingCategory={props.trackingCategory}
      slideSize={props.slideSize}
      arrowTrackingCategory={props.arrowTrackingCategory}
      centerArrows
      emptyMessage={props.emptyMessage}
      hideEmptyCarousel={props.hideEmptyCarousel}
      linkHref={props.linkHref}
      minSize={props.minSize}
      titleElement={props.titleElement}
      linkText={props.linkText}
      linkTracker={trackLinkClick}
      onDataLoad={props.onDataLoad}
    />
  );
}

AuthorCardCarouselWithGraphQL.propTypes = {
  fetchResponseItems: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  queryParams: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  trackingCategory: PropTypes.string.isRequired,
  slideSize: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]).isRequired,
  minSize: PropTypes.number,
  arrowTrackingCategory: PropTypes.string,
  emptyMessage: PropTypes.string,
  hideArrows: PropTypes.bool,
  hideEmptyCarousel: PropTypes.bool,
  linkHref: PropTypes.string,
  linkText: PropTypes.string,
  onDataLoad: PropTypes.func,
  titleElement: PropTypes.oneOf(['div', 'h2', 'h3']),
  trackingProperties: PropTypes.object,
};

AuthorCardCarouselWithGraphQL.defaultProps = {
  minSize: 0,
  queryParams: {},
  hideEmptyCarousel: false,
  onDataLoad: _.noop,
  trackingProperties: {},
};
